/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { ICoreContext } from '@msdyn365-commerce/core';
import { Customer } from '@msdyn365-commerce/retail-proxy';
import { ProductSearchResultExt } from '../types';
import { BuyValidationResult } from '../../modules/defa-search/defa-search'; // Assuming BuyValidationResult is defined here or needs to be imported from a common place
import { showToast } from '../../components/toast/toast';

/**
 * Validates if a product can be bought based on customer access.
 * @param context The context.
 * @param orgInformation The organization information.
 * @param product The product to validate.
 * @param toastNoAccessToProduct The toast message for no access.
 * @returns The validation result.
 */
export const onBuyHasAccessValidator = (
    context: ICoreContext,
    orgInformation: Customer | undefined,
    product: ProductSearchResultExt,
    toastNoAccessToProduct: string
): BuyValidationResult => {
    if (!orgInformation || !product) {
        showToast(context, {
            message: toastNoAccessToProduct,
            title: 'Error',
            type: 'error'
        });
        return { isValid: false, message: toastNoAccessToProduct };
    }

    return { isValid: true };
};
